// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./list-widget.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./boards-config-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./dialogs.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./monitor.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./arduino-select.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./status-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./terminal.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./editor.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./settings-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./firmware-uploader-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./ide-updater-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./certificate-uploader-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./user-fields-dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./debug.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./sketchbook.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./cloud-sketchbook.css";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_18___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./custom-codicon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_19___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./progress-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_20___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./settings-step-input.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/loading-light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../icons/loading-dark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_18___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_19___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --arduino-button-height: 28px;
}

/* Revive of the \`--theia-icon-loading\`. The variable has been removed from Theia while IDE2 still uses is. */
/* The SVG icons are still part of Theia (1.31.1) */
/* https://github.com/arduino/arduino-ide/pull/1662#issuecomment-1324997134 */
body {
    --theia-icon-loading: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --theia-icon-loading-warning: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
body.theia-dark {
    --theia-icon-loading: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    --theia-icon-loading-warning: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.theia-input.warning:focus {
    outline-width: 1px;
    outline-style: solid;
    outline-offset: -1px;
    opacity: 1 !important;
    color: var(--theia-warningForeground);
    background-color: var(--theia-warningBackground);
}

.theia-input.warning {
    background-color: var(--theia-warningBackground);
}

.theia-input.warning::placeholder {
    color: var(--theia-warningForeground);
    background-color: var(--theia-warningBackground);
}

.theia-input.error:focus {
    outline-width: 1px;
    outline-style: solid;
    outline-offset: -1px;
    opacity: 1 !important;
    color: var(--theia-errorForeground);
    background-color: var(--theia-errorBackground);
}

.theia-input.error {
    background-color: var(--theia-errorBackground);
}

.theia-input.error::placeholder {
    color: var(--theia-errorForeground);
    background-color: var(--theia-errorBackground);
}

/* Makes the sidepanel a bit wider when opening the widget */
.p-DockPanel-widget {
    min-width: 220px;
    min-height: 20px;
    height: 220px;
}

/* Overrule the default Theia CSS button styles. */
button.theia-button,
.theia-button {
    align-items: center;
    display: flex;
    font-family: "Open Sans Bold", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    justify-content: center;
    cursor: pointer;
    letter-spacing: 0.01em;
    line-height: 24px;
    outline: none;
    padding: 0 16px;
    position: relative;
    text-align: center;
    text-decoration: none;
    border-width: 2px;
    border-radius: 32px;
    text-transform: uppercase;
    transition: none;
    box-shadow: none;
}

button.theia-button {
    height: var(--arduino-button-height);
    max-width: none;
}

.theia-button:active,
.theia-button:focus {
    box-shadow: 0 0 0 2px var(--theia-focusBorder);
}

button.theia-button.secondary {
    border: 2px solid var(--theia-secondaryButton-foreground);
}

button.theia-button[disabled],
.theia-button[disabled] {
    opacity: 0.5;
    color: var(--theia-button-foreground);
    background-color: var(--theia-button-background);
}

button.secondary[disabled],
.theia-button.secondary[disabled] {
    color: var(--theia-secondaryButton-foreground);
    background-color: var(--theia-secondaryButton-background);
}

button.theia-button.message-box-dialog-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}

/* To make the progress-bar slightly thicker, and use the color from the status bar */
.theia-progress-bar-container {
    width: 100%;
    height: 4px;
}

.theia-progress-bar {
    height: 4px;
    width: 3%;
    animation: progress-animation 1.3s 0s infinite
        cubic-bezier(0.645, 0.045, 0.355, 1);
}

.theia-notification-item-progressbar {
    height: 4px;
    width: 66%;
}

.flex-line {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.fa-reload {
    font-size: 14px;
}

.debug-toolbar .debug-action > div {
    font-family: var(--theia-ui-font-family);
    font-size: var(--theia-ui-font-size0);
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    min-height: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/index.css"],"names":[],"mappings":"AAsBA;IACI,6BAA6B;AACjC;;AAEA,6GAA6G;AAC7G,mDAAmD;AACnD,6EAA6E;AAC7E;IACI,6DAAqD;IACrD,qEAA4D;AAChE;AACA;IACI,6DAAoD;IACpD,qEAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA,4DAA4D;AAC5D;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA,kDAAkD;AAClD;;IAEI,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;;IAEI,YAAY;IACZ,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;;IAEI,8CAA8C;IAC9C,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,qFAAqF;AACrF;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT;4CACwC;AAC5C;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["@import \"./list-widget.css\";\r\n@import \"./boards-config-dialog.css\";\r\n@import \"./main.css\";\r\n@import \"./dialogs.css\";\r\n@import \"./monitor.css\";\r\n@import \"./arduino-select.css\";\r\n@import \"./status-bar.css\";\r\n@import \"./terminal.css\";\r\n@import \"./editor.css\";\r\n@import \"./settings-dialog.css\";\r\n@import \"./firmware-uploader-dialog.css\";\r\n@import \"./ide-updater-dialog.css\";\r\n@import \"./certificate-uploader-dialog.css\";\r\n@import \"./user-fields-dialog.css\";\r\n@import \"./debug.css\";\r\n@import \"./sketchbook.css\";\r\n@import \"./cloud-sketchbook.css\";\r\n@import \"./fonts.css\";\r\n@import \"./custom-codicon.css\";\r\n@import \"./progress-bar.css\";\r\n@import \"./settings-step-input.css\";\r\n\r\n:root {\r\n    --arduino-button-height: 28px;\r\n}\r\n\r\n/* Revive of the `--theia-icon-loading`. The variable has been removed from Theia while IDE2 still uses is. */\r\n/* The SVG icons are still part of Theia (1.31.1) */\r\n/* https://github.com/arduino/arduino-ide/pull/1662#issuecomment-1324997134 */\r\nbody {\r\n    --theia-icon-loading: url(../icons/loading-light.svg);\r\n    --theia-icon-loading-warning: url(../icons/loading-dark.svg);\r\n}\r\nbody.theia-dark {\r\n    --theia-icon-loading: url(../icons/loading-dark.svg);\r\n    --theia-icon-loading-warning: url(../icons/loading-light.svg);\r\n}\r\n\r\n.theia-input.warning:focus {\r\n    outline-width: 1px;\r\n    outline-style: solid;\r\n    outline-offset: -1px;\r\n    opacity: 1 !important;\r\n    color: var(--theia-warningForeground);\r\n    background-color: var(--theia-warningBackground);\r\n}\r\n\r\n.theia-input.warning {\r\n    background-color: var(--theia-warningBackground);\r\n}\r\n\r\n.theia-input.warning::placeholder {\r\n    color: var(--theia-warningForeground);\r\n    background-color: var(--theia-warningBackground);\r\n}\r\n\r\n.theia-input.error:focus {\r\n    outline-width: 1px;\r\n    outline-style: solid;\r\n    outline-offset: -1px;\r\n    opacity: 1 !important;\r\n    color: var(--theia-errorForeground);\r\n    background-color: var(--theia-errorBackground);\r\n}\r\n\r\n.theia-input.error {\r\n    background-color: var(--theia-errorBackground);\r\n}\r\n\r\n.theia-input.error::placeholder {\r\n    color: var(--theia-errorForeground);\r\n    background-color: var(--theia-errorBackground);\r\n}\r\n\r\n/* Makes the sidepanel a bit wider when opening the widget */\r\n.p-DockPanel-widget {\r\n    min-width: 220px;\r\n    min-height: 20px;\r\n    height: 220px;\r\n}\r\n\r\n/* Overrule the default Theia CSS button styles. */\r\nbutton.theia-button,\r\n.theia-button {\r\n    align-items: center;\r\n    display: flex;\r\n    font-family: \"Open Sans Bold\", sans-serif;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    letter-spacing: 0.01em;\r\n    line-height: 24px;\r\n    outline: none;\r\n    padding: 0 16px;\r\n    position: relative;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    border-width: 2px;\r\n    border-radius: 32px;\r\n    text-transform: uppercase;\r\n    transition: none;\r\n    box-shadow: none;\r\n}\r\n\r\nbutton.theia-button {\r\n    height: var(--arduino-button-height);\r\n    max-width: none;\r\n}\r\n\r\n.theia-button:active,\r\n.theia-button:focus {\r\n    box-shadow: 0 0 0 2px var(--theia-focusBorder);\r\n}\r\n\r\nbutton.theia-button.secondary {\r\n    border: 2px solid var(--theia-secondaryButton-foreground);\r\n}\r\n\r\nbutton.theia-button[disabled],\r\n.theia-button[disabled] {\r\n    opacity: 0.5;\r\n    color: var(--theia-button-foreground);\r\n    background-color: var(--theia-button-background);\r\n}\r\n\r\nbutton.secondary[disabled],\r\n.theia-button.secondary[disabled] {\r\n    color: var(--theia-secondaryButton-foreground);\r\n    background-color: var(--theia-secondaryButton-background);\r\n}\r\n\r\nbutton.theia-button.message-box-dialog-button {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n}\r\n\r\n/* To make the progress-bar slightly thicker, and use the color from the status bar */\r\n.theia-progress-bar-container {\r\n    width: 100%;\r\n    height: 4px;\r\n}\r\n\r\n.theia-progress-bar {\r\n    height: 4px;\r\n    width: 3%;\r\n    animation: progress-animation 1.3s 0s infinite\r\n        cubic-bezier(0.645, 0.045, 0.355, 1);\r\n}\r\n\r\n.theia-notification-item-progressbar {\r\n    height: 4px;\r\n    width: 66%;\r\n}\r\n\r\n.flex-line {\r\n    display: flex;\r\n    align-items: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.fa-reload {\r\n    font-size: 14px;\r\n}\r\n\r\n.debug-toolbar .debug-action > div {\r\n    font-family: var(--theia-ui-font-family);\r\n    font-size: var(--theia-ui-font-size0);\r\n    display: flex;\r\n    align-items: center;\r\n    align-self: center;\r\n    justify-content: center;\r\n    min-height: inherit;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
